import { render, staticRenderFns } from "./OilTrackerDetailByCar.vue?vue&type=template&id=4dd37990&scoped=true"
import script from "./OilTrackerDetailByCar.vue?vue&type=script&lang=js"
export * from "./OilTrackerDetailByCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd37990",
  null
  
)

export default component.exports